<template>
  <div>
    <a-form-model layout="inline" :model="formInline">
      <a-form-model-item>
        <a-input
          v-model="formInline.keyword"
          :placeholder="$t('peopleManagement.workerName')"
          @input="posHanlder"
          allowClear
        >
          <template #prefix>
            <a-icon type="search" />
          </template>
        </a-input>
      </a-form-model-item>
      <a-form-model-item v-if="isShowSelector">
        <a-select
          v-model="formInline.jobPosition"
          :placeholder="$t('peopleManagement.position')"
          style="width: 180px"
          :options="getJobPositionLists"
          @change="posHanlder"
          allowClear
        >
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="isShowWorkType">
        <a-select
          v-model="formInline.jobType"
          placeholder="工种"
          style="width: 180px"
          @change="posHanlder"
          :options="getJobTypeLists"
          allowClear
        >
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class CarForm extends Vue {
  @Prop({ type: Array, default: () => [] }) deviceLists;
  @Prop({ type: Array, default: () => [] }) getJobTypeLists;
  @Prop({ type: Array, default: () => [] }) getJobPositionLists;
  @Prop({ type: Boolean, default: true }) isShowWorkType;
  @Prop({ type: Boolean, default: true }) isShowSelector;
  formInline = {
    keyword: '',
    jobPosition: undefined,
    jobType: undefined,
  };
  posHanlder() {
    // console.log(this.formInline);
    this.$emit('handleSearch', this.formInline);
  }
}
</script>
<style lang="less" scoped></style>
